import { Reservation, ReservationStatus } from './types'

// Финальные статусы — зеркалит scope `past` в модели Reservation
const PAST_STATUSES: ReservationStatus[] = [
  ReservationStatus.SEATED,
  ReservationStatus.CANCELLED_BY_CUSTOMER,
  ReservationStatus.CANCELLED_BY_LOCATION,
]

export const isPastReservation = (reservation: Reservation): boolean =>
  PAST_STATUSES.includes(reservation.status) || new Date(reservation.reservationAt).getTime() < Date.now()

export type ReservationGroup = {
  history: Reservation[]
  upcoming: Reservation[]
}

export const groupReservations = (reservations: Reservation[]): ReservationGroup => {
  const grouped: ReservationGroup = { upcoming: [], history: [] }

  reservations.forEach((reservation) => {
    grouped[isPastReservation(reservation) ? 'history' : 'upcoming'].push(reservation)
  })

  grouped.upcoming.sort((a, b) => new Date(a.reservationAt).getTime() - new Date(b.reservationAt).getTime())
  grouped.history.sort((a, b) => new Date(b.reservationAt).getTime() - new Date(a.reservationAt).getTime())

  return grouped
}

// Пока нет серверного поля "можно ли отменить" (см. вопрос 5) — считаем
// отменяемыми все нефинальные статусы, а реальный запрет ловим по ошибке мутации.
export const isCancellable = (reservation: Reservation): boolean => !isPastReservation(reservation)

export const STATUS_LABEL: Record<ReservationStatus, string> = {
  requested: 'Requested',
  suggested: 'New time suggested',
  expected: 'Upcoming',
  confirmed: 'Confirmed',
  seated: 'Completed',
  cancelled_by_customer: 'Cancelled',
  cancelled_by_location: 'Cancelled by restaurant',
}

// CSS custom property names — resolve with var() at the call site so the
// value tracks the active theme.
export const STATUS_COLOR_VAR: Record<ReservationStatus, string> = {
  requested: '--color-info',
  suggested: '--color-warning',
  expected: '--color-info',
  confirmed: '--color-success',
  seated: '--color-text-weak',
  cancelled_by_customer: '--color-danger',
  cancelled_by_location: '--color-danger',
}
